import React from 'react';
import { ApolloClient, ApolloProvider as ApolloProviderService, InMemoryCache, ApolloLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

import { API_URL } from '../../constants/global';
import { useAuth } from "../../hooks/useAuth";
import { errorLink } from './links';
import { authMiddleware } from "../utils/utils";

export const uploadLink = createUploadLink({ uri: API_URL });

interface IApolloProviderProps {
  children: any;
}

export const ApolloProvider: React.FunctionComponent<IApolloProviderProps> = (
  { children }: any,
) => {
  const { token, signOut } = useAuth();

  const apolloClient = new ApolloClient({
    link: ApolloLink.from([
      authMiddleware(token),
      errorLink(signOut),
      uploadLink,
    ]),
    cache: new InMemoryCache(),
  });

  return (
    <ApolloProviderService client={apolloClient}>
      {children}
    </ApolloProviderService>
  );
};
